export enum ReasonTypeEnum {
	All = 1,
    PassengerNoShow = 2,
    PassengerIsWithChild = 3,
    TooManyPassengersOrLuggage = 4,
    CreatePaymentFailed = 5,
    Accident = 6,
    DoubleBooking = 7,
    PassengerChangedMind = 8,
    PassengerHasDesignated = 9,
    NoSignal = 10,
    WrongPin = 11,
    GrayButtonCantSwipe = 12,
    LowBattery = 13,
    Other = 100
}
